import { partial } from 'superstruct';

import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewPromotionAssetDto } from './promotion-asset.dto';

const PromotionAssetSortableFields: (keyof ViewPromotionAssetDto)[] = [
	'id',
	'name',
	'occasion',
	'language',
	'promoType',
	'startDate',
	'endDate',
	'promotionStartDate',
	'promotionEndDate',
	'createdAt',
	'updatedAt',
] as const;

export const DEFAULT_PROMOTION_ASSET_SORT = 'updatedAt';
export const DEFAULT_PROMOTION_ASSET_SORT_DIR = 'desc';

export const ListPromotionAssetSort = partial(
	SortQueryDefaulted(
		PromotionAssetSortableFields,
		DEFAULT_PROMOTION_ASSET_SORT,
		DEFAULT_PROMOTION_ASSET_SORT_DIR
	)
);
